<template>
  <div class="Administrator" v-loading="loading">
    <div class="Administrator-first">
      <div class="Administrator-first-block">
        <div class="first-block-list" v-for="(item, index) in 5" :key="index">
          <div class="first-block-list-title">
            {{
              index == 0
                ? 'id'
                : index == 1
                ? 'id名称'
                : index == 2
                ? '操作类型'
                : index == 3
                ? '操作模块'
                : index == 4
                ? '操作日期'
                : ''
            }}
          </div>
          <div class="first-block-list-input" v-if="index != 4">
            <el-input
              v-if="index == 0"
              placeholder="请输入id"
              v-model="userId"
              clearable
            >
            </el-input>
            <el-input
              v-if="index == 1"
              placeholder="请输入id名称"
              v-model="userName"
              clearable
            >
            </el-input>

            <el-select
              v-if="index == 2"
              v-model="operationType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in operationList"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>

            <el-select
              v-if="index == 3"
              v-model="operationModule"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in operationModuleList"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>

          <div class="first-block-list-picker" v-else>
            <el-date-picker
              v-model="operationTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator=""
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="Administrator-first-button">
        <div class="Administrator-first-button-left" @click="detailInquire">
          查询
        </div>
        <div class="Administrator-first-button-right" @click="detailReset">
          重置
        </div>
      </div>
    </div>

    <div class="Administrator-second">
      <div class="Administrator-second-text">查询结果</div>
      <div class="Administrator-second-table">
        <el-table
          :data="firstTable"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column prop="adminId" label="id"></el-table-column>
          <el-table-column prop="userName" label="id名称"></el-table-column>
          <el-table-column prop="title" label="操作类型"></el-table-column>
          <el-table-column prop="model" label="操作模块"></el-table-column>
          <el-table-column
            prop="content"
            label="操作内容"
            width="377"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="操作时间"
            width="171"
          ></el-table-column>
          <el-table-column prop="ip" label="操作IP"></el-table-column>
        </el-table>
      </div>

      <div class="Administrator-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdministrator } from '../../api/role'

export default {
  data() {
    return {
      // 第一区域参数 id
      userId: '',
      // 第一区域 id名称
      userName: '',
      // 操作类型
      operationType: '',
      operationList: [
        {
          value: 0,
          label: '新增',
        },
        {
          value: 1,
          label: '修改',
        },
        {
          value: 2,
          label: '删除',
        },
        {
          value: 3,
          label: '查看',
        },
      ],
      // 操作模块
      operationModule: '',
      operationModuleList: [
        {
          value: 0,
          label: '登录模块',
        },
        {
          value: 1,
          label: '订单模块',
        },
        {
          value: 2,
          label: '商品模块',
        },
        {
          value: 3,
          label: '红包模块',
        },
        {
          value: 4,
          label: '用户模块',
        },
        {
          value: 5,
          label: '金刚区模块',
        },

        {
          value: 6,
          label: '敏感词模块',
        },
        {
          value: 7,
          label: '供应商模块',
        },
        {
          value: 8,
          label: '大转盘模块',
        },
        {
          value: 9,
          label: '隐私协议模块',
        },
         {
          value: 10,
          label: '联系我们模块',
        },
        {
          value: 11,
          label: '帮助中心模块',
        },

        {
          value: 12,
          label: '关于我们模块',
        },
        {
          value: 13,
          label: '消息管理模块',
        },
        {
          value: 14,
          label: '售后订单模块',
        },
        {
          value: 15,
          label: '积分商品模块',
        },

        {
          value: 16,
          label: '运费规则模块',
        },
        {
          value: 17,
          label: '每日爆款模块',
        },
        {
          value: 18,
          label: '限时秒杀模块',
        },
         {
          value: 19,
          label: '金刚区商品模块',
        },
        {
          value: 20,
          label: '搜索关键词模块',
        },
        {
          value: 21,
          label: '首页轮播图模块',
        },
        {
          value: 22,
          label: '商品一级分类模块',
        },

        {
          value: 23,
          label: '商品二级分类模块',
        },
      ],
      // 操作日期
      operationTime: [],
      // 用户操作日期的时候起始值
      operationTimeA: '',
      // 用户操作日期的时候结尾值
      operationTimeB: '',
      // 第二区域
      firstTable: [],
      // 总条数
      totalNum: 0,

      // 页码
      page: 1,
      // 页数
      limit: 10,
      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      roleFunShow: true,
    }
  },
  created() {
    // 获取管理员接口
    this.loading = true
    this.getAdministratorClick()
  },
  methods: {
    // 第一区域 查询
    detailInquire() {
      this.loading = true

      if (this.operationTime != null) {
        this.operationTimeA = this.operationTime[0]
        this.operationTimeB = this.operationTime[1]
      } else {
        this.operationTimeA = ''
        this.operationTimeB = ''
      }

      this.page = 1

      this.$nextTick(() => {
        this.getAdministratorClick()
      })
    },
    // 第二区域 重置
    detailReset() {
      this.loading = true
      this.userId = ''
      this.userName = ''
      this.operationType = ''
      this.operationModule = ''
      this.operationTime = []
      this.limit = 10
      this.page = 1

      this.getAdministratorClick()
    },

    // 获取管理员日志数据接口
    getAdministratorClick() {
      let params = {
        id: this.userId, // 管理员id
        phone: '', // 手机号
        userName: this.userName, // 用户名 id名称
        nickname: '', // 昵称
        position: '', // 职位
        title: this.operationType, // 操作类型 你写死字符串传就是了 三个类型
        model: this.operationModule, // 操作模块
        createStartTime: this.operationTimeA, // 操作开始时间 ymdhis
        createEndTime: this.operationTimeB, // 操作结束时间ymdhis
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      getAdministrator(params).then((res) => {
        console.log('查看管理员日志接口', res)
        if (res.resultStatus == true) {
          this.firstTable = res.resultData.adminLogList
          // 总条数
          this.totalNum = res.resultData.totalNum

          this.loading = false
        }
      })
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.getAdministratorClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.getAdministratorClick()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.Administrator {
  .Administrator-first {
    height: 180px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 30px 24px;
    box-sizing: border-box;

    .Administrator-first-block {
      display: flex;
      align-items: center;

      .first-block-list {
        margin-right: 24px;
        .first-block-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 4px;
        }

        .first-block-list-input {
          width: 180px;
          height: 32px;
          background: #ffffff;
          border-radius: 5px;

          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }
        }

        .first-block-list-picker {
          width: 385px;
          /deep/ .el-input__inner {
            height: 32px;
          }

          /deep/ .el-range-editor.el-input__inner {
            padding: 0;
            padding: 0 12px;
            box-sizing: border-box;
          }

          /deep/ .el-date-editor--daterange.el-input__inner {
            width: 100%;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 26px;
            padding: 0;
            height: 32px;
            line-height: 32px;
            background-image: url('../../assets/activities/activities-right.png');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .first-block-list:last-child {
        margin-right: 0;
      }
    }

    .Administrator-first-button {
      display: flex;
      margin-top: 27px;

      .Administrator-first-button-left,
      .Administrator-first-button-right {
        width: 110px;
        height: 36px;
        background: #222222;
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }

      .Administrator-first-button-right {
        background: #f4f5f9;
        color: #999999;
        margin-left: 10px;
      }
    }
  }

  .Administrator-second {
    padding: 0 24px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;
    .Administrator-second-text {
      height: 68px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #222222;
    }

    .Administrator-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }
    }

    .Administrator-second-Pagination {
      height: 80px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>
